/** List/download link label: single volume → "ZIP"; multi → "ZIP-1", "ZIP-2", … */
export function exportZipLinkLabel(volumeIndex: number, totalVolumes: number): string {
  if (totalVolumes <= 1) return "ZIP";
  return `ZIP-${volumeIndex}`;
}
